import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-prestacao-conta`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMotoristas(queryParms) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        },
        getDestinos(queryParms) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        },
        getVeiculos(queryParms) {
            return repository.get(`${baseUrl}/veiculo?${urlUtil.serialize(queryParms)}`)
        },
    }
}
